"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("./privacy-policy.component.scss.shim.ngstyle");
var i1 = require("@angular/core");
var i2 = require("./privacy-policy.component");
var styles_PrivacyPolicyComponent = [i0.styles];
var RenderType_PrivacyPolicyComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_PrivacyPolicyComponent, data: {} });
exports.RenderType_PrivacyPolicyComponent = RenderType_PrivacyPolicyComponent;
function View_PrivacyPolicyComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "div", [["class", "container pt-2 pb-2"]], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" Privacy Policy "]))], null, null); }
exports.View_PrivacyPolicyComponent_0 = View_PrivacyPolicyComponent_0;
function View_PrivacyPolicyComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-privacy-policy", [], null, null, null, View_PrivacyPolicyComponent_0, RenderType_PrivacyPolicyComponent)), i1.ɵdid(1, 114688, null, 0, i2.PrivacyPolicyComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
exports.View_PrivacyPolicyComponent_Host_0 = View_PrivacyPolicyComponent_Host_0;
var PrivacyPolicyComponentNgFactory = i1.ɵccf("app-privacy-policy", i2.PrivacyPolicyComponent, View_PrivacyPolicyComponent_Host_0, {}, {}, []);
exports.PrivacyPolicyComponentNgFactory = PrivacyPolicyComponentNgFactory;
